// What a screen that says "revenue" counts, in the same words wherever it says it (QA-714): the one
// definition is the server's (packages/modules shared/revenue.ts), and the books differ from it only
// where they must.

/** Reports, Performance and every technician's share. */
export const REVENUE_WORDS =
  'Revenue is the invoices issued, before tax, less the credit notes given on them, each on its own date.';

/** Where the books' income can differ from that revenue, and why. */
export const BOOKS_INCOME =
  'The books count the same invoices and credit notes, but a membership as its visits are done, not when it’s sold.';
